module.exports = __webpack_public_path__ + "img/0Q3A5746_L_WoodMatted_MockedUp.bf87d272.jpg";